const React = require("react");
const T = React.PropTypes;

require("./SummarySection.less");

const ContentBlock = require("~/components/ContentBlock/ContentBlock.jsx");
const SectionType = require("~/types/Section.js").PropType;

const Question = require("../SummaryQuestion/SummaryQuestion.jsx");

function questionsByDisplayOrder(q1, q2) {
    if (q1.DisplayOrder > q2.DisplayOrder) return 1;

    if (q1.DisplayOrder < q2.DisplayOrder) return -1;

    if (q1.GUID > q2.GUID) return 1;

    return -1;
}

const SummarySection = React.createClass({
    propTypes: {
        PageIDPath: T.arrayOf(T.string).isRequired,
        Section: SectionType.isRequired,
        IsReadOnly: T.bool.isRequired
    },
    render() {
        const contentBlocks = this.props.Section.Questions
            .sort(questionsByDisplayOrder)
            .map(this.MakeContentBlock);

        return (<section className="cs-SummarySection">
            <ol className="cs-SummarySection__list">
                {contentBlocks}
            </ol>
        </section>);
    },

    MakeContentBlock(q, i) {
        const sectionIDPath = this.props.PageIDPath.concat(this.props.Section.GUID);

        if (this.props.Section.Questions.length === 1) {
            return (<ContentBlock key={i}>
                <div className="cs-SummarySection__title"
                dangerouslySetInnerHTML={{ __html: this.props.Section.TitleHTML }}></div>
               <Question Question={q} IsReadOnly={this.props.IsReadOnly} SectionIDPath={sectionIDPath} />
                <div className="cs-SummarySection__Score">{this.GetSectionScore()}</div>
            </ContentBlock>);
        }
        else if (i === 0) {
            return (<ContentBlock key={i}>
                <div className="cs-SummarySection__title"
                     dangerouslySetInnerHTML={{ __html: this.props.Section.TitleHTML }
                }></div>
               <Question Question={q} IsReadOnly={this.props.IsReadOnly} SectionIDPath={sectionIDPath} />
            </ContentBlock>);
        }
        else if (i === this.props.Section.Questions.length - 1) {
            return (<ContentBlock key={i}>
                <Question Question={q} IsReadOnly={this.props.IsReadOnly} SectionIDPath={sectionIDPath} />
            <div className="cs-SummarySection__Score">{this.GetSectionScore()}</div>
            </ContentBlock>);
        }
        else {
            return (<ContentBlock key={i}>
        <Question Question={q} IsReadOnly={this.props.IsReadOnly} SectionIDPath={sectionIDPath} />
            </ContentBlock>);
        }
    },

    GetSectionScore() {        
        const score = this.props.Section.Score;
        const maxScore = this.props.Section.MaxScore;

        const pct = maxScore === 0 
            ? 0 
            : (score / maxScore).toFixed(2)

        return `Score: ${score}/${maxScore} - ${pct}%`;
    }
});

module.exports = SummarySection;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SummarySection/SummarySection.jsx